/* ═══════════════════════════════════════════════════════════
   DARF — Product page: variant picker, gallery, ATC form, qty
   Loaded only on product pages (via main-product.liquid).
   Depends on: darf-utils.js, darf-cart.js
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var u = window.DarfUtils;
  if (!u) return;

  var $ = u.$, $$ = u.$$, on = u.on, money = u.money;

  /* ── Variant picker ─────────────────────────────────────── */
  var variantInput   = $('[name="id"]');
  var priceEl        = document.getElementById('product-price');
  var comparePriceEl = document.getElementById('product-compare-price');
  var pricePerKgEl   = document.getElementById('product-price-per-kg');
  var shippingEl     = document.getElementById('product-shipping');
  var variantData    = [];

  try {
    var dataEl = document.getElementById('variant-data');
    if (dataEl) variantData = JSON.parse(dataEl.textContent);
  } catch (e) {}

  function getSelectedOptions() {
    return $$('[data-option-index]').map(function (group) {
      var active = $('[data-variant-btn].is-active', group);
      return active ? active.dataset.value : null;
    });
  }

  function updateVariant(match) {
    if (!match) return;
    if (variantInput) variantInput.value = match.id;
    if (priceEl) priceEl.textContent = money(match.price);
    if (comparePriceEl) {
      comparePriceEl.textContent = match.compare_at_price > match.price
        ? money(match.compare_at_price) : '';
    }
    if (pricePerKgEl && match.weight > 0) {
      var kg = match.weight / 1000;
      pricePerKgEl.textContent = '(' + money(match.price / kg) + '/kg)';
    }
    if (shippingEl) {
      var dot = shippingEl.querySelector('.product-info__shipping-dot');
      if (dot) dot.classList.toggle('is-out', !match.available);
      var strong = shippingEl.querySelector('strong');
      if (strong) strong.textContent = match.available ? (shippingEl.dataset.inStockLabel || 'Auf Lager') : (shippingEl.dataset.soldOutLabel || 'Ausverkauft');
    }
    var atcBtn = $('[type="submit"].atc-btn') || $('.atc-btn[type="submit"]');
    if (atcBtn) {
      atcBtn.disabled = !match.available;
      atcBtn.textContent = match.available ? 'In den Warenkorb' : 'Ausverkauft';
    }
  }

  $$('[data-option-index]').forEach(function (group) {
    $$('[data-variant-btn]', group).forEach(function (btn) {
      on(btn, 'click', function () {
        $$('[data-variant-btn]', group).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var selected = getSelectedOptions();
        var match = variantData.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        if (match) updateVariant(match);
      });
    });
  });

  /* ── Gallery thumbnails ─────────────────────────────────── */
  var mainImg = document.getElementById('main-product-img');
  $$('[data-thumb]').forEach(function (thumb) {
    on(thumb, 'click', function () {
      $$('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
    });
    on(thumb, 'keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); thumb.click(); }
    });
  });

  /* ── ATC form ───────────────────────────────────────────── */
  var atcForm = document.getElementById('atc-form');
  if (atcForm) {
    on(atcForm, 'submit', function (e) {
      e.preventDefault();
      if (!window.DarfCart) return;
      var variantId = parseInt($('[name="id"]', atcForm).value, 10);
      var qty = parseInt(($('[name="quantity"]', atcForm) || {}).value || 1, 10);
      var btn = $('[type="submit"]', atcForm);
      var orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';
      DarfCart.add(variantId, qty)
        .then(function () {
          btn.textContent = '✓ Hinzugefügt';
          btn.style.background = 'var(--mid-green)';
          setTimeout(function () { btn.textContent = orig; btn.style.background = ''; btn.disabled = false; }, 1800);
        })
        .catch(function () {
          btn.textContent = 'Fehler — bitte erneut versuchen';
          btn.style.background = '#c0392b';
          setTimeout(function () { btn.textContent = orig; btn.style.background = ''; btn.disabled = false; }, 2500);
        });
    });

    on($('[data-qty-minus]', atcForm), 'click', function () {
      var inp = $('[name="quantity"]', atcForm);
      if (inp) inp.value = Math.max(1, parseInt(inp.value, 10) - 1);
    });
    on($('[data-qty-plus]', atcForm), 'click', function () {
      var inp = $('[name="quantity"]', atcForm);
      if (inp) inp.value = parseInt(inp.value, 10) + 1;
    });
  }
})();
